import React, { useState } from "react";
import type { CallbackEvent } from "@shopify/polaris-types";
import type { ProvinceOption } from "../../hooks/useProvinces";

interface ProvinceSelectorProps {
  rateId: string;
  provinces: ProvinceOption[];
  loading: boolean;
  selectedCodes: string[];
  onToggle: (code: string) => void;
  onRemove: (code: string) => void;
}

export const ProvinceSelector: React.FC<ProvinceSelectorProps> = ({
  rateId,
  provinces,
  loading,
  selectedCodes,
  onToggle,
  onRemove,
}) => {
  const [search, setSearch] = useState("");

  const filtered = search
    ? provinces.filter((p) =>
        p.name.toLowerCase().includes(search.toLowerCase())
      )
    : provinces;

  return (
    <s-stack direction="block" gap="small-200">
      <s-text type="strong">Seleccionar provincias</s-text>
      <s-text-field
        label=""
        name={`rate_state_search_${rateId}`}
        value={search}
        placeholder="Buscar provincia"
        onInput={(event: CallbackEvent<"s-text-field">) =>
          setSearch(event.currentTarget.value)
        }
      />

      {/* Selected chips */}
      {selectedCodes.length > 0 && (
        <s-stack direction="inline" gap="small-200">
          {selectedCodes.map((code) => {
            const prov = provinces.find((p) => p.code === code);
            return (
              <s-badge key={code} tone="info">
                {prov?.name ?? code}{" "}
                <span
                  style={{ cursor: "pointer", marginLeft: "4px" }}
                  onClick={() => onRemove(code)}
                >
                  &times;
                </span>
              </s-badge>
            );
          })}
        </s-stack>
      )}

      {/* Province list */}
      {loading ? (
        <s-spinner />
      ) : (
        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
          <s-box
            padding="small-200"
            border="small subdued solid"
            borderRadius="base"
          >
            <s-stack direction="block" gap="small-100">
              {filtered.map((prov) => {
                const isSelected = selectedCodes.includes(prov.code);
                return (
                  <s-checkbox
                    key={prov.code}
                    {...({
                      label: prov.name,
                      checked: isSelected,
                      onChange: () => onToggle(prov.code),
                    } as any)}
                  />
                );
              })}
              {filtered.length === 0 && (
                <s-text color="subdued">No se encontraron provincias.</s-text>
              )}
            </s-stack>
          </s-box>
        </div>
      )}
    </s-stack>
  );
};
